'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _htmlToReact = require('html-to-react');

var _htmlToReact2 = _interopRequireDefault(_htmlToReact);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _heading = require('../../../atoms/heading');

var _heading2 = _interopRequireDefault(_heading);

var _button = require('../../../atoms/button');

var _button2 = _interopRequireDefault(_button);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var htmlToReactParser = new _htmlToReact2.default.Parser();

var renderHeadline = function renderHeadline(headline) {
  if (headline) {
    return _react2.default.createElement(
      _heading2.default,
      {
        level: '2',
        className: 'showcase__headline col-xs-12 col-md-10 center-block text-xs-center'
      },
      htmlToReactParser.parse(headline.text)
    );
  }
  return null;
};

var renderParagraph = function renderParagraph(paragraph) {
  if (paragraph && paragraph.text) {
    return _react2.default.createElement(
      'p',
      { className: 'showcase__paragraph col-xs-12 col-md-10 center-block text-xs-center' },
      htmlToReactParser.parse(paragraph.text)
    );
  }
  return null;
};

var renderPrimaryCta = function renderPrimaryCta(primaryCta) {
  if (primaryCta && primaryCta.text) {
    var targetValue = primaryCta.target || '_self';
    return _react2.default.createElement(
      _button2.default,
      {
        href: primaryCta.href,
        id: primaryCta.id,
        className: 'showcase__btn center-block',
        fpti: 'ShowCase-PrmryCTA-' + primaryCta.text,
        target: targetValue
      },
      primaryCta.text
    );
  }
  return null;
};

var renderHatchText = function renderHatchText(hatchText) {
  if (hatchText && hatchText.text) {
    return _react2.default.createElement(
      'p',
      { className: 'showcase__hatch-text text-xs-center' },
      htmlToReactParser.parse(hatchText.text)
    );
  }
  return null;
};

var Showcase = function (_React$Component) {
  _inherits(Showcase, _React$Component);

  function Showcase(props) {
    _classCallCheck(this, Showcase);

    var _this = _possibleConstructorReturn(this, (Showcase.__proto__ || Object.getPrototypeOf(Showcase)).call(this, props));

    _this.handleScroll = _this.handleScroll.bind(_this);
    _this.sectionElement = null;
    _this.state = {
      showImages: false
    };
    // adding references in case this component is extended
    _this.renderHeadline = renderHeadline;
    _this.renderParagraph = renderParagraph;
    _this.renderPrimaryCta = renderPrimaryCta;
    _this.renderHatchText = renderHatchText;
    return _this;
  }

  _createClass(Showcase, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var domRect = this.sectionElement && this.sectionElement.getBoundingClientRect();
      if (domRect && window.innerHeight - domRect.top >= 0) {
        this.enableImages();
        return;
      }
      window.addEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('scroll', this.handleScroll);
    }
  }, {
    key: 'enableImages',
    value: function enableImages() {
      this.setState({
        showImages: true
      });
    }
  }, {
    key: 'handleScroll',
    value: function handleScroll() {
      window.removeEventListener('scroll', this.handleScroll);
      this.enableImages();
    }
  }, {
    key: 'renderMerchantLogos',
    value: function renderMerchantLogos(merchantLogos) {
      var _this2 = this;

      var result = merchantLogos.map(function (merchant, index) {
        // creating plain logo
        if (merchant.logo) {
          var columnsClass = {
            3: true,
            5: true,
            6: true
          }[merchantLogos.length] ? 'col-xs-6 col-md-4' : 'col-xs-6 col-md-3';
          var classes = 'text-xs-center showcase__logo showcase__logo-' + index + ' ' + columnsClass;
          var logo = _this2.state.showImages && _react2.default.createElement('img', { src: merchant.logo.src, alt: merchant.logo.alt, className: 'showcase__image' });
          // adding anchor for logo, if it exists
          var renderedLogo = logo;
          if (_this2.props.config.linkForLogos) {
            renderedLogo = _react2.default.createElement(
              'a',
              {
                href: merchant.logo.href,
                rel: 'noopener noreferrer',
                target: '_blank',
                className: 'showcase__links',
                'data-pa-click': 'Showcase-Logo' + index + '-' + (merchant.logo.alt || 'alt')
              },
              logo
            );
          }
          return _react2.default.createElement(
            'div',
            {
              className: classes,
              key: index
            },
            renderedLogo
          );
        }
        return null;
      });
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props,
          content = _props.content,
          config = _props.config,
          className = _props.className;
      var headline = content.headline,
          paragraph = content.paragraph,
          merchantLogos = content.merchantLogos,
          primaryCta = content.primaryCta,
          hatchText = content.hatchText;


      var showcaseClasses = (0, _classnames2.default)('showcase', config.theme, className);
      return _react2.default.createElement(
        'section',
        {
          id: config.id,
          className: showcaseClasses,
          'data-building-block': 'organism',
          ref: function ref(el) {
            _this3.sectionElement = el;
          }
        },
        _react2.default.createElement(
          'div',
          { className: 'container' },
          _react2.default.createElement(
            'div',
            { className: 'row showcase__header' },
            renderHeadline(headline),
            renderParagraph(paragraph)
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(
            'div',
            { className: 'row showcase__container' },
            this.renderMerchantLogos(merchantLogos)
          ),
          renderPrimaryCta(primaryCta),
          renderHatchText(hatchText)
        )
      );
    }
  }]);

  return Showcase;
}(_react2.default.Component);

exports.default = Showcase;


Showcase.propTypes = {
  config: _propTypes2.default.shape({
    id: _propTypes2.default.string,
    theme: _propTypes2.default.oneOf(['theme-background-color-white', 'theme-background-color-light']).isRequired,
    linkForLogos: _propTypes2.default.bool
  }),
  content: _propTypes2.default.shape({
    headline: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }).isRequired,
    paragraph: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    }),
    merchantLogos: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      logo: _propTypes2.default.shape({
        src: _propTypes2.default.string.isRequired,
        alt: _propTypes2.default.string.isRequired,
        href: _propTypes2.default.string
      }).isRequired
    })).isRequired,
    primaryCta: _propTypes2.default.shape({
      href: _propTypes2.default.string.isRequired,
      text: _propTypes2.default.string.isRequired,
      id: _propTypes2.default.string,
      target: _propTypes2.default.oneOf(['_self', '_blank'])
    }),
    hatchText: _propTypes2.default.shape({
      text: _propTypes2.default.string.isRequired
    })
  }),
  className: _propTypes2.default.string
};

Showcase.defaultProps = {
  config: {
    id: '',
    theme: 'theme-background-color-white',
    linkForLogos: false
  },
  content: {
    headline: {
      text: '35 characters maximum'
    },
    paragraph: {
      text: '110 characters maximjm of text or words which equal ' + 'no more than 4 lines of copy on mobile devices.'
    },
    merchantLogos: [{
      logo: {
        src: 'https://www.paypalobjects.com/webstatic/en_CA/mktg/where-to-use-paypal/fashion/Adidas.png',
        alt: 'Adidas',
        href: '#'
      }
    }, {
      logo: {
        src: 'https://www.paypalobjects.com/webstatic/en_CA/mktg/where-to-use-paypal/fashion/Adidas.png',
        alt: 'Adidas',
        href: '#'
      }
    }, {
      logo: {
        src: 'https://www.paypalobjects.com/webstatic/en_CA/mktg/where-to-use-paypal/fashion/Adidas.png',
        alt: 'Adidas',
        href: '#'
      }
    }],
    primaryCta: {
      href: '#',
      text: '29 characters maximum',
      target: '_self'
    },
    hatchText: {
      text: '34 characters maximum per line'
    }
  },
  className: ''
};


//////////////////
// WEBPACK FOOTER
// /donatenodeweb-ci-2793/workspace/donate-gro-release/~/marketing-components/dist/components/organisms/showcase/jsx/Showcase.js
// module id = 1139
// module chunks = 4